import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

import { ApiObject, School } from 'app/types';

import styles from './Tabs.module.scss';
import { useMediaQuery } from 'react-responsive';
import { navigateTop } from 'common/utils';

interface CompProps {
  school: ApiObject<School> | undefined;
  schoolTopic: number;
}

interface CheckProps {
  text: string;
}

const CheckComponent = ({ text }: CheckProps): React.ReactElement => {
  return (
    <div className={styles.checkContainer}>
      <i className="bi bi-check-circle-fill"> </i>
      <p> {text} </p>
    </div>
  );
};

export const TabsComponent = ({ school, schoolTopic }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { schoolSlug } = useParams<{ schoolSlug: string }>();
  const [schoolId] = schoolSlug?.split('--') || [];
  const { ref: tabsRef, inView: tabsInView } = useInView({
    threshold: 1,
  });
  const { ref: mobileTabsRef, inView: mobileRefInView } = useInView({
    threshold: 1,
  });

  const showVisaSection = useMemo(
    () =>
      (school?.data.city.country.working_visa_number &&
        school?.data.city.country.working_visa_format) ||
      school?.data.city.country.working_visa_after_study ||
      school?.data.city.country.visa_description,
    [school]
  );

  const showCareerSection = useMemo(
    () =>
      school?.data.school_rankings?.[0] ||
      (school?.data.working_after_months && school?.data.working_after_percentage) ||
      school?.data.alumni_information ||
      (school?.data.companies && school?.data.companies.length > 0) ||
      school?.data.career_service_description,
    [school]
  );

  return (
    <div className={styles.sectionsTabsDT}>
      {isMobile ? (
        <div className={styles.tabsContainer}>
          <div className={styles.mobileTabsRef} ref={mobileTabsRef} />
          <div className={`${styles.blockTabs} ${!mobileRefInView ? styles.fixedTabs : ''}`}>
            <a
              className={`${styles.tabs} ${schoolTopic === 0 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'overview', true, true)}
            >
              Overview
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 1 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'study', true, true)}
            >
              Programs
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 2 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'apply', true, true)}
            >
              Apply
            </a>
            {showCareerSection && (
              <a
                className={`${styles.tabs} ${schoolTopic === 3 ? styles.active : ''}`}
                onClick={() => navigateTop(0, 0, 'career', true, true)}
              >
                Career
              </a>
            )}
            {showVisaSection && (
              <a
                className={`${styles.tabs} ${schoolTopic === 4 ? styles.active : ''}`}
                onClick={() => navigateTop(0, 0, 'visa', true, true)}
              >
                Visa
              </a>
            )}
            <a
              className={`${styles.tabs} ${schoolTopic === 5 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'student-life', true, true)}
            >
              Student life
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 6 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'faq', true, true)}
            >
              FAQs & links
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 7 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'similar-schools', true, true)}
            >
              Similar schools
            </a>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.referenceDiv} ref={tabsRef}></div>
          <div className={`${styles.blockTabs} ${tabsInView ? styles.notFixed : styles.fixedTabs}`}>
            <a
              className={`${styles.tabs} ${schoolTopic === 0 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'overview', true, true)}
            >
              Overview
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 1 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'study', true, true)}
            >
              Programs
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 2 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'apply', true, true)}
            >
              Apply
            </a>
            {showCareerSection && (
              <a
                className={`${styles.tabs} ${schoolTopic === 3 ? styles.active : ''}`}
                onClick={() => navigateTop(0, 0, 'career', true, true)}
              >
                Career
              </a>
            )}
            {showVisaSection && (
              <a
                className={`${styles.tabs} ${schoolTopic === 4 ? styles.active : ''}`}
                onClick={() => navigateTop(0, 0, 'visa', true, true)}
              >
                Visa
              </a>
            )}
            <a
              className={`${styles.tabs} ${schoolTopic === 5 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'student-life', true, true)}
            >
              Student life
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 6 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'faq', true, true)}
            >
              FAQs & links
            </a>
            <a
              className={`${styles.tabs} ${schoolTopic === 7 ? styles.active : ''}`}
              onClick={() => navigateTop(0, 0, 'similar-schools', true, true)}
            >
              Similar schools
            </a>
            <a
              className="btn btn-primary btn-lg"
              href={`https://unifyapply.com/experts/request-meeting?school_id=${school?.data.id}&school_name=${school?.data.name}`}
            >
              Check my elegibility
            </a>
            <CheckComponent text="Learn more about the university" />
            <CheckComponent text="Get your admission chances" />
            <CheckComponent text="Tailored application plan for you" />
          </div>
        </>
      )}
    </div>
  );
};
